import * as React from "react";
import { useConvexAuth } from "convex/react";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";
import { NavItemData } from "./nav.tsx";

/** How many things are in a list, beside it in the nav. Nothing for an empty one. */
export const NavCount: React.FC<{ kind: NonNullable<NavItemData["countKind"]> }> = ({ kind }) => {
  // The More sheet that shows these is mounted on the sign-in page too
  const { isAuthenticated } = useConvexAuth();
  const count = useQuery(api.items.count, isAuthenticated ? { statusKind: kind } : "skip");
  if (!count) return null;
  return <span className="sidebar-count">{count >= 500 ? "500+" : count}</span>;
};
